// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"124":"9d78c252","2044":"891cff7f"}[chunkId] || chunkId) + "." + {"124":"3aa4b7a419ff6678","1949":"8da6faf23d6b944a","2044":"ce86a83bb4601af6","3588":"6af016d9320c006f","4282":"a709f726d5cce316","4954":"870ee44bfb0ccec7","6505":"7b92df5e3aa44072","8690":"3987e2ee9a7f0ecf"}[chunkId] + ".js";
};